import React from "react";
import { Box, Button, Grid, Paper, FormControl, Container, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";
import IPDCFormHeader from "./IPDCFormHeader";

//prettier-ignore
const FormWrapper = styled(Paper)(({ theme }) => (
  {
    padding: theme.spacing(4), 
    width: "100%", 
    maxWidth: 1400,
    margin: "0 auto",
    [theme.breakpoints.up('xl')]: {
      maxWidth: 1600,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '95%',
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: theme.spacing(2),
    }
  }
));

//prettier-ignore
const FormContainer = ({ 
  title, 
  children, 
  onSubmit, 
  showButton = true, 
  buttonLabel = "Submit", 
  showTitle = true, 
  extraInfoAfterButton = null,
  maxWidth = 1400,
  fullWidth = false
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const wrapperStyle = fullWidth ? {
    maxWidth: '100% !important',
    width: '100%'
  } : {};

  return (
    <Container 
      sx={{ 
        width: "100%", 
        height: isSmallScreen ? "auto" : "60%", 
        alignItems: "center", 
        mt: 1,
        px: { xs: 1, sm: 2, md: 3 }
      }} 
    >
      <FormWrapper elevation={3} sx={wrapperStyle}>
        <Box component="form" onSubmit={onSubmit}>
          <Grid container spacing={isSmallScreen ? 1 : 2}>
            {showTitle && (
              <Grid item xs={12}>
                <IPDCFormHeader title={title} />
              </Grid>
            )}
            {children}
            {showButton && (
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  
                </Box>
              </Grid>
            )}
            {extraInfoAfterButton && (
              <Grid item xs={12}>
                {extraInfoAfterButton}
              </Grid>
            )}
          </Grid>
        </Box>
      </FormWrapper>
    </Container>
  );
};

export default FormContainer;